import React from 'react';
import AssistantIcon from '@material-ui/icons/Assistant';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectArrayInput,
    CustomSelectInput,
} from 'candy-commons-components';
import constants from 'candy-commons/constants';
import {
    ArrayInput,
    Create,
    FormDataConsumer,
    SimpleForm,
    SimpleFormIterator,
    TextInput,
    useTranslate,
} from 'react-admin';
import COUNTRIES from '../../data/countries.json';
import { useStyles } from './styles';
import { useSelector } from 'react-redux';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
} from '../../selectors/cmsConfig';
const EcoEvents = constants.EcoEvents;
const EligibleAppliances = (props) => {
    const translation = useTranslate();
    const styles = useStyles();
    const brands = useSelector(getBrands);
    const applianceTypes = useSelector(getApplianceTypes);
    const series = useSelector(getSeries);
    const breadcrumbsData = [
        {
            text: translation('resources.eligible-appliances.name'),
            url: 'eligible-appliances',
            icon: <AssistantIcon />,
        },
        {
            text: translation('resources.eligible-appliances.create.name'),
            url: '',
        },
    ];
    const getFilteredEvents = (applianceType) => {
        if (applianceType) {
            applianceType = applianceType === 'WM-WD' ? 'WM' : applianceType;
            return EcoEvents.filter((evt) =>
                evt?.applianceTypes.includes(applianceType)
            );
        }
        return [];
    };
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm redirect="list">
                    <ContainerFieldsList>
                        <ContainerFieldsList>
                            <TextInput
                                source="energyProviderKey"
                                label="Energy Provider"
                                required
                            />
                            <CustomSelectArrayInput
                                required
                                label="Countries"
                                source="countries"
                                choices={COUNTRIES}
                            />
                        </ContainerFieldsList>
                        <ArrayInput
                            className={styles.arrayInput}
                            source="applianceEligibility"
                            label="Appliance Eligibility"
                        >
                            <SimpleFormIterator
                                className={{ form: styles.form }}
                                getItemLabel={(index) => `${index + 1}-key`}
                            >
                                <CustomSelectInput
                                    source="applianceType"
                                    choices={applianceTypes}
                                    required
                                />
                                <TextInput source="country" required />
                                <CustomSelectInput
                                    source="brand"
                                    allowEmpty
                                    choices={brands}
                                />
                                <CustomSelectInput
                                    source="series"
                                    allowEmpty
                                    choices={series}
                                />
                                <TextInput source="seriesVersion" required />
                                <FormDataConsumer>
                                    {({
                                        formData,
                                        scopedFormData,
                                        getSource,
                                        ...rest
                                    }) => (
                                        <CustomSelectArrayInput
                                            choices={getFilteredEvents(
                                                scopedFormData?.applianceType
                                            )}
                                            translateChoice={false}
                                            label="Events Subscription"
                                            source={getSource(
                                                'eventSubscription'
                                            )}
                                            {...rest}
                                        />
                                    )}
                                </FormDataConsumer>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};
export default EligibleAppliances;
